import { ethers } from "ethers"
import { decimalToHex } from "../decimalToHex"
import { formatCalldata } from "../formatCalldata"
import { ProductCart } from "./cartProductTypes"

export async function updateAllowedItems({
  cart,
  checkAllowedItems,
  buyer,
  provider
}: {
  cart: ProductCart[]
  checkAllowedItems: ProductCart[]
  buyer: string
  provider: ethers.providers.JsonRpcProvider | ethers.providers.FallbackProvider
}) {
  const updatedCart = [...cart]

  if (buyer) {
    const args: any[] = []
    const contracts: string[] = []
    const signatures: string[] = []

    checkAllowedItems.forEach((el) => {
      const { slicerId, productId, quantity } = el
      // [slicerId, productId, account, quantity, extData, buyerCustomData]
      contracts.push(el.extCheckAddress)
      signatures.push(el.extCheckSig)
      args.push(
        formatCalldata(
          decimalToHex(slicerId),
          decimalToHex(productId),
          buyer,
          decimalToHex(quantity),
          "0x",
          "0x"
        )
      )
    })

    const results = await extMulticall(contracts, signatures, args, provider)

    results.forEach((result, i) => {
      const { slicerId, productId } = checkAllowedItems[i]

      const cartIndex = updatedCart.findIndex(
        (el) => el.slicerId == slicerId && el.productId == productId
      )

      updatedCart[cartIndex].isAllowed = Number(result) === 1
    })
  } else {
    updatedCart.map((el) => {
      if (el.isAllowed) {
        el.isAllowed = false
      }
      return el
    })
  }

  return updatedCart
}

const extMulticall = async (
  to: string[],
  functionSelectors: string[],
  args: string[],
  defaultProvider:
    | ethers.providers.JsonRpcProvider
    | ethers.providers.FallbackProvider
) => {
  const promises = []

  args.forEach((arg, i) => {
    const data = functionSelectors[i] + arg
    promises.push(
      defaultProvider.call({
        to: to[i],
        data
      })
    )
  })

  const results = await Promise.all(promises.map((p) => p.catch(() => "")))

  return results
}

// export async function updateAllowedItems({
//   cart,
//   checkAllowedItems,
//   address
// }: {
//   cart: ProductCart[]
//   checkAllowedItems: ProductCart[]
//   address: string
// }) {
//   const args: any[] = []
//   const contracts: `0x${string}`[] = []
//   const signatures: string[] = []
//   const updatedCart = [...cart]

//   // TODO: Fix Extcall
//   checkAllowedItems.forEach((el) => {
//     const { slicerId, productId, quantity } = el
//     // [slicerId, productId, account, quantity, extData, buyerCustomData]
//     contracts.push(el.extCheckAddress)
//     signatures.push(el.extCheckSig)
//     args.push([slicerId, productId, address, quantity, "", ""])
//   })

//   const results = await multicall(contracts, abi, functionName, args)

//   results.forEach((result, i) => {
//     const { slicerId, productId } = checkAllowedItems[i]

//     const cartIndex = updatedCart.findIndex(
//       (el) => el.slicerId == slicerId && el.productId == productId
//     )

//     updatedCart[cartIndex].isAllowed = Number(result) === 1
//   })

//   return updatedCart
// }
